import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import {
  Button,
  CardActions,
  CircularProgress,
  withStyles,
} from '@material-ui/core';
import {
  PasswordField,
  renderFormFieldInput as renderInput,
} from '../components';
import { formStyles as styles } from '../styles';

const LoginForm = withStyles(styles)(props => {
  const { requestLogin, hasRegistration, registrationPathname } = props;
  const translate = useTranslate();
  const [isLoading, setLoading] = useState(false);

  return (
	<Form
		validate={values => {
        const errors = {};
        if (!values.username)
          errors.username = translate('ra.validation.required');
        if (!values.password)
          errors.password = translate('ra.validation.required');
        return errors;
		}}
		onSubmit={values => {
        requestLogin(values, setLoading);
		}}
		{...props}
	>
		{({ classes, handleSubmit, submitting }) => (
			<form onSubmit={e => handleSubmit(e)}>
				<div className={classes.form}>
					<div className={classes.input}>
						<Field
							id="username"
							name="username"
							label={translate('ra.auth.username')}
							render={renderInput}
							disabled={isLoading || submitting}
              />
					</div>
					<div className={classes.input}>
						<PasswordField
							isFormLoading={isLoading || submitting}
							fieldComponent={renderInput}
              />
					</div>
				</div>
				<div className={classes.cardActions}>
					<CardActions>
						<Link className={classes.forgotPasswordLink} to="/forgotPassword">
							{translate('authentication.login.forgotPassword', {
                  _: 'Forgot password?',
                })}
						</Link>
					</CardActions>
					<CardActions>
						<Button
							type="submit"
							disabled={isLoading}
							variant="text"
							className={classes.button}
						>
							{isLoading ? (
								<CircularProgress
									size={25}
									thickness={3}
									className={classes.loadingIndicator}
                  />
                ) : (
                  translate('authentication.login.submit', { _: 'Login' })
                )}
						</Button>
					</CardActions>
					{!isLoading && hasRegistration && (
						<CardActions>
							<Button
								disabled={isLoading}
								className={classes.button}
								component={Link}
								to={{
                    pathname: registrationPathname,
								}}
							>
								{translate('authentication.register.submit', {
                    _: 'Register',
                  })}
							</Button>
						</CardActions>
            )}
				</div>
			</form>
      )}
	</Form>
  );
});

LoginForm.propTypes = {
  classes: PropTypes.object,
  requestLogin: PropTypes.func.isRequired,
};

LoginForm.defaultProps = {
  classes: null,
};

export default LoginForm;
